export default __webpack_public_path__ + "static/media/5.c7e78414.jpg";